<template>
  <div>
    <router-view></router-view>
  </div>
  
</template>

<script >
// import { ElButton } from 'element-plus'
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
  
  },
}
</script>

<style>
html,body {
  margin: 0;
  padding: 0;
}
#app {
  height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
